import GoogleRatingBadge from '@/components/reviews/GoogleRatingBadge';

export default function GoogleRatingPlacement({ en = false }) {
  return <aside className="mt-8 flex justify-center" aria-label={en ? 'Customer reviews' : 'Kundeanmeldelser'}>
    <GoogleRatingBadge en={en} />
  </aside>;
}